import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ValidatorService } from './validator.service';


export class DefaultValidatorService implements ValidatorService {

  getRowValidator(): FormGroup {
    return new FormGroup({});
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
